import HtmlDiffModule from 'htmldiff-js';

const HtmlDiff = HtmlDiffModule.default ?? HtmlDiffModule;

export default HtmlDiff;